import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { EntityGroupHeaderDTO, FieldConfigDTO, MenuDTO } from '../../../../../system/system-dtos';
import { MyErrorStateMatcher } from '../../../../../common/field-validation/my-error-state-matcher';
import { ActionService } from '../../../../action/action.service';
import { isDefined, notDefined } from '../../../../utils/utils';

@Component({
  selector: 'app-entity-group-header',
  templateUrl: './entity-group-header.component.html',
  styleUrls: ['./entity-group-header.component.scss'],
  standalone: false,
})
export class EntityGroupHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Output() loadingEmitter = new EventEmitter<boolean>();

  @Output() headerInitialized = new EventEmitter<any>();

  @Output() refreshSignalled: EventEmitter<void> = new EventEmitter<void>();

  @Input() menuConfig: MenuDTO;

  @Input() groupConfig: MenuDTO;

  @Input() data: any;

  @Input() displayHeader: boolean = true;

  @Input() entityId: string;

  @Input() entityGroupId: string;

  @Input() code: string;

  @Input() editMode: boolean;

  @Input() mode: number;

  @Input() refreshSubject: Subject<void>;

  private refreshSubscription: Subscription;

  public headerConfig: EntityGroupHeaderDTO;

  public headerData: any;

  public loading = true;

  public formGroup: UntypedFormGroup;

  public backgroundColor = 'rgba(50,50,50)';

  public fontColor = 'black';

  public title: string;

  public image: string;

  public status: string;

  public actionInProgress: boolean;

  refreshTimer: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private actionService: ActionService
  ) {}

  ngOnDestroy(): void {
    try {
      if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
      }
      if (isDefined(this.refreshTimer)) {
        clearInterval(this.refreshTimer);
      }
    } catch (err) {
      console.log('Error cancelling timer - ignoring ', err);
    }
  }

  ngOnInit() {
    this.headerInitialized.emit(null);
    this.loading = true;
    if (this.menuConfig.entityGroup && this.menuConfig.entityGroup.header && !this.editMode) {
      this.headerConfig = this.menuConfig.entityGroup.header;
      let url = this.headerConfig.url.replace(/{.+?}/, this.entityId);
      if (isDefined(this.entityGroupId)) {
        url = this.headerConfig.url.replace(/{.+?}/, this.entityId).replace(/{.+?}/, this.entityGroupId);
      }

      // this.http.get(this.headerConfig.url.replace('{id}', this.entityId))
      this.http.get(url).subscribe({
        next: (d) => {
          this.handleHeaderData(d);
          this.headerData = d || {};
          this.loading = false;
          this.headerInitialized.emit(d);
        },
        error: (err) => {
          this.loading = false;
          this.title = 'Header cannot not be presented due to unexpected error, please refresh the page!';
          this.headerConfig = null;
          this.headerInitialized.emit({});
        },
      });
    } else {
      this.title = this.menuConfig.singleForm ? this.menuConfig.singleForm.title : this.menuConfig.entityGroup.title;
      this.headerInitialized.emit({});
      this.headerConfig = null;
      this.loading = false;
    }

    if (isDefined(this.menuConfig) && isDefined(this.menuConfig.refreshRate) && this.menuConfig.refreshRate > 0) {
      if (notDefined(this.refreshTimer)) {
        this.refreshTimer = setInterval(
          () => {
            this.signalRefresh();
          },
          this.menuConfig.refreshRate < 1000 ? this.menuConfig.refreshRate * 1000 : this.menuConfig.refreshRate
        );
      }
    }

    this.refreshSubscription = this.refreshSubject.subscribe((_) => {
      this.ngOnDestroy();
      this.ngOnInit();
    });
  }

  forwardLoadingEmitter(actionInProgress: boolean) {
    this.actionInProgress = actionInProgress;
    this.loadingEmitter.emit(actionInProgress);
    if (!actionInProgress) {
      this.ngOnDestroy();
      this.ngOnInit();
    }
  }

  private handleHeaderData(headerData: any) {
    const header = headerData;
    this.backgroundColor = eval(this.headerConfig.backgroundColor);
    this.fontColor = eval(this.headerConfig.fontColor);
    this.title = eval(this.headerConfig.title);
    this.image = eval(this.headerConfig.image);
    this.status = eval(this.headerConfig.status);
    const fieldsToDisplay = this.headerConfig.rows[0].columns
      .map((c) => c.fields)
      .reduce((acc, elem) => acc.concat(elem), []);
    this.formGroup = this.constructFormGroup(fieldsToDisplay, headerData);
  }

  private constructFormGroup(fieldsToDisplay: FieldConfigDTO[], headerData: any) {
    const formGroupBuilder = {};
    fieldsToDisplay.forEach((f) => (formGroupBuilder[f.name] = this.getFormControlForField(f, headerData)));
    const formGroup = new UntypedFormGroup(formGroupBuilder);
    return formGroup;
  }

  private getFormControlForField(f: FieldConfigDTO, headerData: any) {
    const disabled = f.editReadOnly;

    const value = headerData[f.name];
    const validators = MyErrorStateMatcher.convertToAngularValidators([f]);
    const formControl = new UntypedFormControl(
      {
        value,
        disabled,
      },
      validators
    );
    return formControl;
  }

  private anyAction(): boolean {
    return (
      this.headerConfig.actions.filter(
        (a) => !this.actionService.determineIsDisabled(this.headerData, a.jsEditCondition)
      ).length > 0
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.code && !changes.code.firstChange) || (changes.entityId && !changes.entityId.firstChange)) {
      this.ngOnDestroy();
      this.ngOnInit();
    }
  }

  signalRefresh() {
    this.refreshSignalled.emit();
  }

  navigateBack() {
    this.router.navigate([this.code], { relativeTo: this.route.parent });
  }
}
